import { getRailLabel } from "../constants";
import { PaymentRailIcon } from "./PaymentRailIcon";

export const PaymentRailChip = ({
  railId,
  currencyId,
  className = "",
  showLabel = true,
  fixedWidth = false,
}) => {
  const label = getRailLabel(railId);
  const currency = currencyId?.toUpperCase() ?? "";

  if (!railId && !currency) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs text-brand-dark dark:text-gray-100 ${
        fixedWidth ? "w-[7.5rem] shrink-0 justify-center overflow-hidden" : ""
      } ${className}`}
    >
      {railId ? <PaymentRailIcon railId={railId} /> : null}
      {showLabel && label ? (
        <span className={fixedWidth ? "min-w-0 truncate" : ""}>{label}</span>
      ) : null}
      {currency ? (
        <span className="shrink-0 font-medium text-gray-500 dark:text-gray-400">{currency}</span>
      ) : null}
    </span>
  );
};
